import { ICustomExperienceAssistant } from "../../../interfaces/customer-experience-assistant/ICustomExperienceAssistant";
import { classNames } from "../../../utils/classNames";

const AverageRating = ({
  customerExperienceAssistant: { averageRating, averageSentiment, reviewCount },
}: {
  customerExperienceAssistant: ICustomExperienceAssistant;
}) => {
  const renderSegments = (type: "positive" | "negative" | "neutral") => (
    <div className="w-full flex flex-wrap items-center my-1">
      <div
        className={classNames(
          "w-3/12 text-base tracking-wide font-semibold capitalize",
          type === "positive" ? "text-[#008000] " : "",
          type === "negative" ? "text-[#FF0000] " : "",
          type === "neutral" ? "text-[#FFA500] " : ""
        )}
      >
        {type}
      </div>
      <div className="w-7/12">
        <div className="w-full h-2 rounded-lg bg-[#D9D9D9]">
          <div
            className={classNames(
              "h-2 rounded-lg w-0",
              type === "positive" ? "bg-[#008000] " : "",
              type === "negative" ? "bg-[#FF0000] " : "",
              type === "neutral" ? "bg-[#FFA500] " : ""
            )}
            style={{
              width: `${parseFloat(averageSentiment[type]) * 100}%`,
            }}
          />
        </div>
      </div>
      <div className="w-2/12 text-right text-base tracking-wide font-semibold">
        {Number(parseFloat(averageSentiment[type]) * 100).toFixed(2)}%
      </div>
    </div>
  );

  const renderStars = (rate: number) =>
    Array.from({ length: rate }, (_, i) => (
      <img alt="star" className="w-7 h-7" src="/assets/shared/star.svg" />
    ));
  return (
    <div className="flex flex-wrap my-4 -mx-2">
      <div className="w-full md:w-6/12 px-2">
        <div className="bg-white rounded-2xl py-10 px-5">
          <h4 className="font-semibold text-lg md:text-2xl">Average Rating</h4>
          <div className="my-3">
            <h2 className="text-2xl md:text-5xl font-black tracking-wide my-2 flex flex-row">
              {averageRating}
              <div className="flex flex-row items-center ml-3">
                {renderStars(Number(averageRating))}
              </div>
            </h2>
            <p className="text-[#0E0F0C80] text-opacity-50 text-base font-normal">
              From {reviewCount} reviews
            </p>
          </div>
        </div>
      </div>
      <div className="w-full md:w-6/12 px-2">
        <div className="bg-white rounded-2xl py-10 px-5">
          <h4 className="font-semibold text-lg md:text-xl">Average Rating</h4>
          <div className="my-3">
            {renderSegments("positive")}
            {renderSegments("neutral")}
            {renderSegments("negative")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AverageRating;
